import { io } from "socket.io-client";

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  "http://localhost:5000";

let socket = null;

const getMainAppAuth = () => ({
  token: localStorage.getItem("tokenl"),
  userid: localStorage.getItem("userid"),
  devId: localStorage.getItem("dev_id"),
});

export const connectSocket = () => {
  if (socket?.connected) {
    console.log(
      "🟢 AVIATOR SOCKET ALREADY CONNECTED:",
      socket.id
    );

    return socket;
  }

  if (socket) {
    return socket;
  }

  const { userid, devId } = getMainAppAuth();

  console.log("=================================");
  console.log("🔌 AVIATOR SOCKET CONNECT");
  console.log("URL:", SOCKET_URL);
  console.log("USER ID:", userid || "MISSING");
  console.log("DEVICE ID:", devId || "MISSING");
  console.log(
    "MAIN TOKEN:",
    localStorage.getItem("tokenl") ? "tokenl available" : "tokenl MISSING"
  );
  console.log("=================================");

  socket = io(SOCKET_URL, {
    transports: ["polling", "websocket"],

    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    timeout: 10000,

    /*
     * Same MAIN APP authentication.
     */
    // runs on every (re)connect so the latest main-app tokenl is always sent
    auth: (cb) => {
      const m = getMainAppAuth();
      cb({ token: m.token, userid: m.userid, userId: m.userid, devId: m.devId });
    },
  });

  socket.on("connect", () => {
    console.log(
      "🟢 AVIATOR SOCKET CONNECTED:",
      socket.id
    );
  });

  socket.on("connect_error", (error) => {
    console.error(
      "🔴 AVIATOR SOCKET ERROR:",
      error?.message || error
    );
  });

  socket.on("disconnect", (reason) => {
    console.log(
      "🟠 AVIATOR SOCKET DISCONNECTED:",
      reason
    );
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (!socket) return;

  console.log("🔌 Disconnecting Aviator socket");

  socket.removeAllListeners();
  socket.disconnect();

  socket = null;
};

export default socket;
